// Traduções do módulo Outros Serviços Transporte, coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'outrosServicos.title': 'Outros Serviços Transporte',
    'outrosServicos.eyebrow': 'Operação',
    'outrosServicos.addTrip': 'Adicionar viagem',
    'outrosServicos.statTotal': 'Viagens',
    'outrosServicos.emptyMessage': 'Nenhuma viagem no recorte.',
    'outrosServicos.retry': 'Tentar de novo',
    'outrosServicos.records_one': '{{count}} viagem',
    'outrosServicos.records_other': '{{count}} viagens',

    'outrosServicos.col.dupla': 'Dupla',
    'outrosServicos.col.inicio': 'Data de início',
    'outrosServicos.col.fim': 'Data de fim',
    'outrosServicos.col.motorista': 'Motorista',
    'outrosServicos.col.placa': 'Placa',
    'outrosServicos.col.carreta': 'Carreta',
    'outrosServicos.col.origem': 'Local de origem',
    'outrosServicos.col.destino': 'Local de destino',
    'outrosServicos.col.statusProtheus': 'Status da viagem no Protheus',
    'outrosServicos.col.viagem': 'Filial/Viagem',
    'outrosServicos.col.statusHub': 'Status da viagem no HUB',
    'outrosServicos.col.notaFiscal': 'Nota fiscal',
    'outrosServicos.col.observacao': 'Observação',
    'outrosServicos.col.acoes': 'Ações',
    'outrosServicos.col.servico': 'Serviço',

    'outrosServicos.cell.naoVinculada': 'Não vinculada',
    'outrosServicos.cell.removida': 'Removida do Protheus',
    'outrosServicos.cell.removidaTooltip': 'A viagem saiu do espelho do Protheus e não voltou. O número continua o mesmo.',
    'outrosServicos.cell.incompativel': 'Agora é {{servico}}',
    'outrosServicos.cell.incompativelTooltip': 'O Protheus passou esta viagem para {{servico}}. Este módulo é para viagem que não é de Prancha nem de Espiga.',
    'outrosServicos.cell.semCerca': 'Sem cerca',
    'outrosServicos.cell.semCercaTooltip': 'O local não tem cerca no cadastro, e a geocerca não avança o status por ele.',
    'outrosServicos.cell.solto': 'Fora de Outros Serviços',
    'outrosServicos.cell.soltoTooltip': 'O conjunto não está mais em Outros Serviços no Painel de Descarga.',
    'outrosServicos.cell.apontado': 'Classificada no módulo de Viagens',
    'outrosServicos.cell.porPadrao': 'Sem serviço cadastrado no Protheus, caiu no padrão',
    'outrosServicos.cell.buscarLocal': 'Buscar local',

    'outrosServicos.filter.de': 'De',
    'outrosServicos.filter.ate': 'Até',
    'outrosServicos.filter.todos': 'Todos',
    'outrosServicos.filter.linhaDoAtalho': 'Linha da pendência',
    'outrosServicos.filter.todas': 'Todas',
    'outrosServicos.filter.buscar': 'Buscar',
    'outrosServicos.filter.semDupla': 'Sem dupla',
    'outrosServicos.filter.semStatus': 'Sem status',
    'outrosServicos.filter.naoVinculada': 'Não vinculada',
    'outrosServicos.filter.semServico': 'Sem serviço',

    'outrosServicos.acao.conjunto': 'Motorista, placa e carreta',
    'outrosServicos.acao.vincular': 'Vincular viagem Protheus',
    'outrosServicos.acao.anomaliaNenhuma': 'Sem anomalias na viagem',
    'outrosServicos.acao.anomalia_one': '1 anomalia na viagem. Clique para ver.',
    'outrosServicos.acao.anomalia_other': '{{count}} anomalias na viagem. Clique para ver.',
    'outrosServicos.acao.historico': 'Histórico da viagem',
    'outrosServicos.acao.reabrir': 'Reabrir viagem',
    'outrosServicos.acao.excluir': 'Excluir viagem',
    'outrosServicos.acao.semPermissao': 'Sem permissão para editar',

    'outrosServicos.anomalia.titulo': 'Anomalias da viagem',
    'outrosServicos.anomalia.motorista': 'Motorista diferente da viagem do Protheus',
    'outrosServicos.anomalia.cavalo': 'Placa diferente da viagem do Protheus',
    'outrosServicos.anomalia.carreta': 'Carreta diferente da viagem do Protheus',
    'outrosServicos.anomalia.noHub': 'No HUB',
    'outrosServicos.anomalia.noProtheus': 'No Protheus',

    'outrosServicos.conjunto.titulo': 'Conjunto da viagem',
    'outrosServicos.conjunto.subtitulo': 'Conjuntos da sua dupla que estão Disponível ou Adiantando no Painel de Descarga.',
    'outrosServicos.conjunto.aviso': 'Ao escalar, o conjunto aparece no Painel de Descarga como Outros Serviços até a viagem fechar.',
    'outrosServicos.conjunto.buscar': 'Buscar motorista ou placa',
    'outrosServicos.conjunto.vazio': 'Nenhum conjunto da sua dupla está Disponível ou Adiantando no Painel de Descarga.',
    'outrosServicos.conjunto.atual': 'Conjunto atual',
    'outrosServicos.conjunto.escalar': 'Escalar',
    'outrosServicos.conjunto.trocar': 'Trocar',
    'outrosServicos.conjunto.tirar': 'Tirar o conjunto',
    'outrosServicos.conjunto.travado': 'A viagem já saiu de Escalado, e o conjunto não muda mais. Encerre como Atendida ou Não atendida.',
    'outrosServicos.conjunto.motorista': 'Motorista',
    'outrosServicos.conjunto.cavalo': 'Placa',
    'outrosServicos.conjunto.carreta': 'Carreta',
    'outrosServicos.conjunto.dupla': 'Dupla',
    'outrosServicos.conjunto.escalado': 'Conjunto escalado. No Painel de Descarga ele aparece como Outros Serviços.',
    'outrosServicos.conjunto.tirado': 'Conjunto retirado. Ele voltou ao status de antes no Painel de Descarga.',

    'outrosServicos.vincular.titulo': 'Vincular viagem Protheus',
    'outrosServicos.vincular.subtitulo': 'Viagens do Protheus que não são de Prancha nem de Espiga. A da placa do conjunto vem primeiro.',
    'outrosServicos.vincular.buscar': 'Buscar por número, placa ou motorista',
    'outrosServicos.vincular.vazio': 'Nenhuma viagem do Protheus disponível para vincular.',
    'outrosServicos.vincular.atual': 'Viagem vinculada',
    'outrosServicos.vincular.acao': 'Vincular',
    'outrosServicos.vincular.desvincular': 'Desvincular',
    'outrosServicos.vincular.sugestao': 'Placa do conjunto',
    'outrosServicos.vincular.feito': 'Viagem do Protheus vinculada.',
    'outrosServicos.vincular.desfeito': 'Viagem do Protheus desvinculada.',

    'outrosServicos.atender.titulo': 'Viagem atendida',
    'outrosServicos.atender.quando': 'Quando o conjunto ficou disponível?',
    'outrosServicos.atender.aviso': 'O conjunto volta a Disponível no Painel de Descarga nesse horário.',
    'outrosServicos.atender.justificativa': 'Justificativa',
    'outrosServicos.atender.justificativaAviso': 'A viagem ainda não chegou a Descarregando. Descreva o motivo.',
    'outrosServicos.atender.antesDaEscala': 'O horário precisa ser posterior à escala, em {{quando}}.',
    'outrosServicos.atender.futuro': 'O horário não pode estar no futuro.',
    'outrosServicos.atender.feito': 'Viagem atendida. O conjunto voltou a Disponível no Painel de Descarga.',

    'outrosServicos.naoAtender.titulo': 'Viagem não atendida',
    'outrosServicos.naoAtender.mensagem': 'O conjunto volta ao status que tinha antes da escala no Painel de Descarga. Descreva o motivo, com pelo menos 10 caracteres.',
    'outrosServicos.reabrir.titulo': 'Reabrir viagem',
    'outrosServicos.reabrir.mensagem': 'A viagem volta à etapa em que estava antes de ser encerrada, e o conjunto volta a Outros Serviços no Painel de Descarga. Descreva o motivo, com pelo menos 10 caracteres.',
    'outrosServicos.etapa.titulo': 'Mudar para {{status}}',
    'outrosServicos.etapa.mensagem': 'A mudança está fora da ordem da viagem. Descreva o motivo para registrar a correção.',
    'outrosServicos.confirmar': 'Confirmar',
    'outrosServicos.cancelar': 'Cancelar',
    'outrosServicos.fechar': 'Fechar',

    'outrosServicos.excluir.titulo': 'Excluir viagem?',
    'outrosServicos.excluir.mensagem': 'A viagem será excluída. Esta ação não pode ser desfeita.',
    'outrosServicos.excluir.feito': 'Viagem excluída.',

    'outrosServicos.historico.titulo': 'Histórico da viagem',
    'outrosServicos.historico.vazio': 'Nenhum registro.',
    'outrosServicos.historico.sistema': 'Sistema',
    'outrosServicos.historico.semStatus': 'Sem status',
    'outrosServicos.historico.semConjunto': 'Sem conjunto',
    'outrosServicos.historico.semViagem': 'Sem viagem',
    'outrosServicos.historico.tipo.criacao': 'Viagem cadastrada',
    'outrosServicos.historico.tipo.status': 'Status',
    'outrosServicos.historico.tipo.conjunto': 'Conjunto',
    'outrosServicos.historico.tipo.vinculo': 'Viagem do Protheus',
    'outrosServicos.historico.tipo.reabertura': 'Reaberta',
    'outrosServicos.historico.tipo.exclusao': 'Excluída',
    'outrosServicos.historico.origem.manual': 'Na tela',
    'outrosServicos.historico.origem.geocerca': 'Geocerca',
    'outrosServicos.historico.origem.painel': 'Painel de Descarga',
    'outrosServicos.historico.origem.troca_ponta': 'Troca de origem ou destino',
    'outrosServicos.historico.origem.reconciliacao': 'Conferência do ciclo',
    'outrosServicos.col.cliente': 'Cliente',
    'outrosServicos.filter.servicoHub': 'Serviço HUB',
    'outrosServicos.filter.clienteHub': 'Cliente HUB',
    'outrosServicos.filter.semClienteHub': 'Sem Cliente HUB',
    'outrosServicos.filter.semVinculo': 'Sem viagem vinculada',
    'outrosServicos.filter.ativasEm': 'Ativas no dia',
    'outrosServicos.filter.naoClassificado': 'Serviço HUB não classificado',
    'outrosServicos.filter.diaria': 'Diária',
    'outrosServicos.cell.naoClassificado': 'Serviço HUB não classificado',
    'outrosServicos.cell.classificadoPor': 'Classificado por {{nome}} em {{quando}}',
    'outrosServicos.cell.semClienteHub': 'Sem Cliente HUB',
    'outrosServicos.cell.semClienteHubTooltip': 'O cliente {{cliente}} do Protheus ainda não está vinculado a um Cliente HUB. O vínculo é feito em Cadastros, na aba Clientes HUB.',
    'outrosServicos.status.diaria': 'Diária',
    'outrosServicos.acao.servicoHub': 'Classificar serviço HUB',
    'outrosServicos.acao.servicoHubIndisponivel': 'Só a viagem vinculada ao Protheus no serviço Outros recebe o Serviço HUB',
    'outrosServicos.acao.diaria': 'Classificar como Diária',
    'outrosServicos.acao.editarDiaria': 'Editar diária',
    'outrosServicos.anomalia.cliente': 'Cliente Protheus sem vínculo com Cliente HUB',
    'outrosServicos.servicoHub.titulo': 'Classificar serviço HUB',
    'outrosServicos.servicoHub.original': 'Serviço no Protheus',
    'outrosServicos.servicoHub.escolha': 'Serviço HUB',
    'outrosServicos.servicoHub.semInternos': 'Nenhum dos Outros Serviços está cadastrado',
    'outrosServicos.servicoHub.dica': 'Os Outros Serviços do cadastro de Serviços. O serviço no Protheus continua como Outros.',
    'outrosServicos.servicoHub.remover': 'Tirar a classificação',
    'outrosServicos.servicoHub.salvo': 'Serviço HUB classificado',
    'outrosServicos.servicoHub.removido': 'Classificação retirada',
    'outrosServicos.diaria.titulo': 'Classificar como Diária',
    'outrosServicos.diaria.editar': 'Editar diária',
    'outrosServicos.diaria.explica': 'A diária não tem cavalo, carreta nem local de destino, e fica sempre como Diária. Se houver conjunto escalado, ele volta ao Painel de Descarga.',
    'outrosServicos.diaria.buscarMotorista': 'Buscar motorista...',
    'outrosServicos.diaria.confirmar': 'Classificar como Diária',
    'outrosServicos.diaria.salva': 'Diária salva',
    'outrosServicos.diaria.classificada': 'Linha classificada como Diária',
    'outrosServicos.historico.tipo.servico_hub': 'Serviço HUB',
    'outrosServicos.historico.tipo.diaria': 'Classificada como Diária',
  },
  en: {
    'outrosServicos.title': 'Other Transport Services',
    'outrosServicos.eyebrow': 'Operations',
    'outrosServicos.addTrip': 'Add trip',
    'outrosServicos.statTotal': 'Trips',
    'outrosServicos.emptyMessage': 'No trips in this range.',
    'outrosServicos.retry': 'Try again',
    'outrosServicos.records_one': '{{count}} trip',
    'outrosServicos.records_other': '{{count}} trips',
    'outrosServicos.col.dupla': 'Pair',
    'outrosServicos.col.inicio': 'Start',
    'outrosServicos.col.fim': 'End',
    'outrosServicos.col.motorista': 'Driver',
    'outrosServicos.col.placa': 'Plate',
    'outrosServicos.col.carreta': 'Trailer',
    'outrosServicos.col.origem': 'Origin',
    'outrosServicos.col.destino': 'Destination',
    'outrosServicos.col.statusProtheus': 'Protheus trip status',
    'outrosServicos.col.viagem': 'Branch/Trip',
    'outrosServicos.col.statusHub': 'HUB trip status',
    'outrosServicos.col.notaFiscal': 'Invoice',
    'outrosServicos.col.observacao': 'Notes',
    'outrosServicos.col.acoes': 'Actions',
    'outrosServicos.col.servico': 'Service',
    'outrosServicos.cell.naoVinculada': 'Not linked',
    'outrosServicos.cell.removida': 'Removed from Protheus',
    'outrosServicos.cell.removidaTooltip': 'The trip left the Protheus mirror and did not come back.',
    'outrosServicos.cell.incompativel': 'Now {{servico}}',
    'outrosServicos.cell.incompativelTooltip': 'Protheus moved this trip to {{servico}}.',
    'outrosServicos.cell.semCerca': 'No geofence',
    'outrosServicos.cell.semCercaTooltip': 'The place has no geofence, so the status does not advance through it.',
    'outrosServicos.cell.solto': 'Out of Other Services',
    'outrosServicos.cell.soltoTooltip': 'The set is no longer in Other Services on the Unloading Board.',
    'outrosServicos.cell.apontado': 'Classified in the Trips module',
    'outrosServicos.cell.porPadrao': 'No Protheus service, default applied',
    'outrosServicos.cell.buscarLocal': 'Search place',
    'outrosServicos.filter.de': 'From',
    'outrosServicos.filter.ate': 'To',
    'outrosServicos.filter.todos': 'All',
    'outrosServicos.filter.linhaDoAtalho': 'Line from pending items',
    'outrosServicos.filter.todas': 'All',
    'outrosServicos.filter.buscar': 'Search',
    'outrosServicos.filter.semDupla': 'No pair',
    'outrosServicos.filter.semStatus': 'No status',
    'outrosServicos.filter.naoVinculada': 'Not linked',
    'outrosServicos.filter.semServico': 'No service',
    'outrosServicos.acao.conjunto': 'Driver, plate and trailer',
    'outrosServicos.acao.vincular': 'Link Protheus trip',
    'outrosServicos.acao.anomaliaNenhuma': 'No anomalies on the trip',
    'outrosServicos.acao.anomalia_one': '1 anomaly on the trip. Click to see.',
    'outrosServicos.acao.anomalia_other': '{{count}} anomalies on the trip. Click to see.',
    'outrosServicos.acao.historico': 'Trip history',
    'outrosServicos.acao.reabrir': 'Reopen trip',
    'outrosServicos.acao.excluir': 'Delete trip',
    'outrosServicos.acao.semPermissao': 'No permission to edit',
    'outrosServicos.anomalia.titulo': 'Trip anomalies',
    'outrosServicos.anomalia.motorista': 'Driver differs from the Protheus trip',
    'outrosServicos.anomalia.cavalo': 'Plate differs from the Protheus trip',
    'outrosServicos.anomalia.carreta': 'Trailer differs from the Protheus trip',
    'outrosServicos.anomalia.noHub': 'In the HUB',
    'outrosServicos.anomalia.noProtheus': 'In Protheus',
    'outrosServicos.conjunto.titulo': 'Trip set',
    'outrosServicos.conjunto.subtitulo': 'Sets of your pair that are Available or Advancing on the Unloading Board.',
    'outrosServicos.conjunto.aviso': 'Once scheduled, the set shows as Other Services on the Unloading Board until the trip closes.',
    'outrosServicos.conjunto.buscar': 'Search driver or plate',
    'outrosServicos.conjunto.vazio': 'No set of your pair is Available or Advancing on the Unloading Board.',
    'outrosServicos.conjunto.atual': 'Current set',
    'outrosServicos.conjunto.escalar': 'Schedule',
    'outrosServicos.conjunto.trocar': 'Swap',
    'outrosServicos.conjunto.tirar': 'Remove the set',
    'outrosServicos.conjunto.travado': 'The trip already left Scheduled, so the set no longer changes. Close it as Attended or Not attended.',
    'outrosServicos.conjunto.motorista': 'Driver',
    'outrosServicos.conjunto.cavalo': 'Plate',
    'outrosServicos.conjunto.carreta': 'Trailer',
    'outrosServicos.conjunto.dupla': 'Pair',
    'outrosServicos.conjunto.escalado': 'Set scheduled. It shows as Other Services on the Unloading Board.',
    'outrosServicos.conjunto.tirado': 'Set removed. It went back to its previous status on the Unloading Board.',
    'outrosServicos.vincular.titulo': 'Link Protheus trip',
    'outrosServicos.vincular.subtitulo': 'Protheus trips that are neither Flatbed nor Corn on the cob. The one with the set plate comes first.',
    'outrosServicos.vincular.buscar': 'Search by number, plate or driver',
    'outrosServicos.vincular.vazio': 'No Protheus trip available to link.',
    'outrosServicos.vincular.atual': 'Linked trip',
    'outrosServicos.vincular.acao': 'Link',
    'outrosServicos.vincular.desvincular': 'Unlink',
    'outrosServicos.vincular.sugestao': 'Set plate',
    'outrosServicos.vincular.feito': 'Protheus trip linked.',
    'outrosServicos.vincular.desfeito': 'Protheus trip unlinked.',
    'outrosServicos.atender.titulo': 'Trip attended',
    'outrosServicos.atender.quando': 'When did the set become available?',
    'outrosServicos.atender.aviso': 'The set goes back to Available on the Unloading Board at this time.',
    'outrosServicos.atender.justificativa': 'Reason',
    'outrosServicos.atender.justificativaAviso': 'The trip has not reached Unloading yet. Describe the reason.',
    'outrosServicos.atender.antesDaEscala': 'The time must be after the scheduling, at {{quando}}.',
    'outrosServicos.atender.futuro': 'The time cannot be in the future.',
    'outrosServicos.atender.feito': 'Trip attended. The set is Available again on the Unloading Board.',
    'outrosServicos.naoAtender.titulo': 'Trip not attended',
    'outrosServicos.naoAtender.mensagem': 'The set goes back to its status before the scheduling. Describe the reason with at least 10 characters.',
    'outrosServicos.reabrir.titulo': 'Reopen trip',
    'outrosServicos.reabrir.mensagem': 'The trip goes back to the stage before it was closed, and the set goes back to Other Services. Describe the reason with at least 10 characters.',
    'outrosServicos.etapa.titulo': 'Change to {{status}}',
    'outrosServicos.etapa.mensagem': 'The change is out of the trip order. Describe the reason to record the correction.',
    'outrosServicos.confirmar': 'Confirm',
    'outrosServicos.cancelar': 'Cancel',
    'outrosServicos.fechar': 'Close',
    'outrosServicos.excluir.titulo': 'Delete trip?',
    'outrosServicos.excluir.mensagem': 'The trip will be deleted. This cannot be undone.',
    'outrosServicos.excluir.feito': 'Trip deleted.',
    'outrosServicos.historico.titulo': 'Trip history',
    'outrosServicos.historico.vazio': 'No records.',
    'outrosServicos.historico.sistema': 'System',
    'outrosServicos.historico.semStatus': 'No status',
    'outrosServicos.historico.semConjunto': 'No set',
    'outrosServicos.historico.semViagem': 'No trip',
    'outrosServicos.historico.tipo.criacao': 'Trip created',
    'outrosServicos.historico.tipo.status': 'Status',
    'outrosServicos.historico.tipo.conjunto': 'Set',
    'outrosServicos.historico.tipo.vinculo': 'Protheus trip',
    'outrosServicos.historico.tipo.reabertura': 'Reopened',
    'outrosServicos.historico.tipo.exclusao': 'Deleted',
    'outrosServicos.historico.origem.manual': 'On screen',
    'outrosServicos.historico.origem.geocerca': 'Geofence',
    'outrosServicos.historico.origem.painel': 'Unloading Board',
    'outrosServicos.historico.origem.troca_ponta': 'Origin or destination change',
    'outrosServicos.historico.origem.reconciliacao': 'Cycle check',
    'outrosServicos.col.cliente': 'Customer',
    'outrosServicos.filter.servicoHub': 'HUB service',
    'outrosServicos.filter.clienteHub': 'HUB customer',
    'outrosServicos.filter.semClienteHub': 'No HUB customer',
    'outrosServicos.filter.semVinculo': 'No linked trip',
    'outrosServicos.filter.ativasEm': 'Active on',
    'outrosServicos.filter.naoClassificado': 'HUB service not classified',
    'outrosServicos.filter.diaria': 'Daily hire',
    'outrosServicos.cell.naoClassificado': 'HUB service not classified',
    'outrosServicos.cell.classificadoPor': 'Classified by {{nome}} on {{quando}}',
    'outrosServicos.cell.semClienteHub': 'No HUB customer',
    'outrosServicos.cell.semClienteHubTooltip': 'The Protheus customer {{cliente}} is not linked to a HUB customer yet. Link it in Records, HUB Customers tab.',
    'outrosServicos.status.diaria': 'Daily hire',
    'outrosServicos.acao.servicoHub': 'Classify HUB service',
    'outrosServicos.acao.servicoHubIndisponivel': 'Only a trip linked to Protheus under the Outros service gets a HUB service',
    'outrosServicos.acao.diaria': 'Classify as daily hire',
    'outrosServicos.acao.editarDiaria': 'Edit daily hire',
    'outrosServicos.anomalia.cliente': 'Protheus customer not linked to a HUB customer',
    'outrosServicos.servicoHub.titulo': 'Classify HUB service',
    'outrosServicos.servicoHub.original': 'Service in Protheus',
    'outrosServicos.servicoHub.escolha': 'HUB service',
    'outrosServicos.servicoHub.semInternos': 'No internal service registered',
    'outrosServicos.servicoHub.dica': 'The internal services of the Services registry. The Protheus service stays as Outros.',
    'outrosServicos.servicoHub.remover': 'Remove classification',
    'outrosServicos.servicoHub.salvo': 'HUB service classified',
    'outrosServicos.servicoHub.removido': 'Classification removed',
    'outrosServicos.diaria.titulo': 'Classify as daily hire',
    'outrosServicos.diaria.editar': 'Edit daily hire',
    'outrosServicos.diaria.explica': 'A daily hire has no truck, trailer or destination, and stays as Daily hire. Any scheduled set returns to the Unloading Board.',
    'outrosServicos.diaria.buscarMotorista': 'Search driver...',
    'outrosServicos.diaria.confirmar': 'Classify as daily hire',
    'outrosServicos.diaria.salva': 'Daily hire saved',
    'outrosServicos.diaria.classificada': 'Row classified as daily hire',
    'outrosServicos.historico.tipo.servico_hub': 'HUB service',
    'outrosServicos.historico.tipo.diaria': 'Classified as daily hire',
  },
  es: {
    'outrosServicos.title': 'Otros Servicios de Transporte',
    'outrosServicos.eyebrow': 'Operación',
    'outrosServicos.addTrip': 'Agregar viaje',
    'outrosServicos.statTotal': 'Viajes',
    'outrosServicos.emptyMessage': 'Ningún viaje en el recorte.',
    'outrosServicos.retry': 'Intentar de nuevo',
    'outrosServicos.records_one': '{{count}} viaje',
    'outrosServicos.records_other': '{{count}} viajes',
    'outrosServicos.col.dupla': 'Dupla',
    'outrosServicos.col.inicio': 'Fecha de inicio',
    'outrosServicos.col.fim': 'Fecha de fin',
    'outrosServicos.col.motorista': 'Conductor',
    'outrosServicos.col.placa': 'Placa',
    'outrosServicos.col.carreta': 'Remolque',
    'outrosServicos.col.origem': 'Origen',
    'outrosServicos.col.destino': 'Destino',
    'outrosServicos.col.statusProtheus': 'Estado del viaje en Protheus',
    'outrosServicos.col.viagem': 'Filial/Viaje',
    'outrosServicos.col.statusHub': 'Estado del viaje en el HUB',
    'outrosServicos.col.notaFiscal': 'Factura',
    'outrosServicos.col.observacao': 'Observación',
    'outrosServicos.col.acoes': 'Acciones',
    'outrosServicos.col.servico': 'Servicio',
    'outrosServicos.cell.naoVinculada': 'No vinculado',
    'outrosServicos.cell.removida': 'Eliminado de Protheus',
    'outrosServicos.cell.semCerca': 'Sin geocerca',
    'outrosServicos.cell.solto': 'Fuera de Otros Servicios',
    'outrosServicos.filter.de': 'Desde',
    'outrosServicos.filter.ate': 'Hasta',
    'outrosServicos.filter.todos': 'Todos',
    'outrosServicos.filter.linhaDoAtalho': 'Línea del pendiente',
    'outrosServicos.filter.todas': 'Todas',
    'outrosServicos.filter.semDupla': 'Sin dupla',
    'outrosServicos.filter.semStatus': 'Sin estado',
    'outrosServicos.filter.naoVinculada': 'No vinculado',
    'outrosServicos.filter.semServico': 'Sin servicio',
    'outrosServicos.acao.vincular': 'Vincular viaje Protheus',
    'outrosServicos.acao.historico': 'Historial del viaje',
    'outrosServicos.acao.reabrir': 'Reabrir viaje',
    'outrosServicos.acao.excluir': 'Eliminar viaje',
    'outrosServicos.confirmar': 'Confirmar',
    'outrosServicos.cancelar': 'Cancelar',
    'outrosServicos.fechar': 'Cerrar',
    'outrosServicos.col.cliente': 'Cliente',
    'outrosServicos.filter.servicoHub': 'Servicio HUB',
    'outrosServicos.filter.clienteHub': 'Cliente HUB',
    'outrosServicos.filter.semClienteHub': 'Sin Cliente HUB',
    'outrosServicos.filter.semVinculo': 'Sin viaje vinculado',
    'outrosServicos.filter.ativasEm': 'Activas el día',
    'outrosServicos.filter.naoClassificado': 'Servicio HUB no clasificado',
    'outrosServicos.filter.diaria': 'Diaria',
    'outrosServicos.cell.naoClassificado': 'Servicio HUB no clasificado',
    'outrosServicos.cell.classificadoPor': 'Clasificado por {{nome}} el {{quando}}',
    'outrosServicos.cell.semClienteHub': 'Sin Cliente HUB',
    'outrosServicos.cell.semClienteHubTooltip': 'El cliente {{cliente}} de Protheus aún no está vinculado a un Cliente HUB. El vínculo se hace en Registros, pestaña Clientes HUB.',
    'outrosServicos.status.diaria': 'Diaria',
    'outrosServicos.acao.servicoHub': 'Clasificar servicio HUB',
    'outrosServicos.acao.servicoHubIndisponivel': 'Solo el viaje vinculado a Protheus en el servicio Outros recibe el Servicio HUB',
    'outrosServicos.acao.diaria': 'Clasificar como Diaria',
    'outrosServicos.acao.editarDiaria': 'Editar diaria',
    'outrosServicos.anomalia.cliente': 'Cliente de Protheus sin vínculo con Cliente HUB',
    'outrosServicos.servicoHub.titulo': 'Clasificar servicio HUB',
    'outrosServicos.servicoHub.original': 'Servicio en Protheus',
    'outrosServicos.servicoHub.escolha': 'Servicio HUB',
    'outrosServicos.servicoHub.semInternos': 'Ningún servicio interno registrado',
    'outrosServicos.servicoHub.dica': 'Los servicios internos del registro de Servicios. El servicio de Protheus sigue como Outros.',
    'outrosServicos.servicoHub.remover': 'Quitar la clasificación',
    'outrosServicos.servicoHub.salvo': 'Servicio HUB clasificado',
    'outrosServicos.servicoHub.removido': 'Clasificación quitada',
    'outrosServicos.diaria.titulo': 'Clasificar como Diaria',
    'outrosServicos.diaria.editar': 'Editar diaria',
    'outrosServicos.diaria.explica': 'La diaria no tiene tractor, remolque ni destino, y queda siempre como Diaria. El conjunto programado vuelve al Panel de Descarga.',
    'outrosServicos.diaria.buscarMotorista': 'Buscar conductor...',
    'outrosServicos.diaria.confirmar': 'Clasificar como Diaria',
    'outrosServicos.diaria.salva': 'Diaria guardada',
    'outrosServicos.diaria.classificada': 'Fila clasificada como Diaria',
    'outrosServicos.historico.tipo.servico_hub': 'Servicio HUB',
    'outrosServicos.historico.tipo.diaria': 'Clasificada como Diaria',
  },
}
